
import React from 'react';
import { UserMenu } from '@/components/auth/UserMenu';
import { Package } from 'lucide-react';

export const DashboardHeader = () => {
  return (
    <div className="bg-white shadow-sm border-b">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Package className="w-8 h-8 text-blue-600" />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Inventory Management</h1>
              <p className="text-sm text-gray-600">Manage your orders and inventory</p>
            </div>
          </div>
          <UserMenu />
        </div>
      </div>
    </div>
  );
};
